<template>
  <section class="detailsPage">
    <Header />
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#E30713"
             :height = 145
             :width = 145
             :opacity = 1
             backgroundColor="#eeeeee"
             :z-index = 3
             :is-full-page="fullPage"
    ></loading>
    <div class="container">
      <div class="row unprint">
        <div class="detailsPage__nav">
          <router-link class="detailsPage__nav-btn" to="/result/">
            <svg width="15" height="10"
                 viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.99412 5H14M4.82353 9L1 5L4.82353 1"
                    stroke="#E30713" stroke-width="2" stroke-miterlimit="22.9256"
                    stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            Total calculation
          </router-link>
          <div class="detailsPage__nav-label">
            Calculation {{ slopeFromState.name }}
          </div>
        </div>
      </div>
      <div class="row align-items-center justify-content-between detailsPage__title-box">
        <div class="detailsPage__title">
          {{ slopeFromState.name }}.
          <span v-if="slopeFromState.slopeType === 'mainSlope'">Main slope</span>
          <span v-else>Counter slope</span>
        </div>
        <div class="d-flex align-items-center flex-row unprint">
          <button @click="isShowDeleteConfirmation = !isShowDeleteConfirmation"
                  class="delete__btn" v-if="this.allSlopes.length !== 1">
            <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 2.91667L18 5.29333M5.73105 3.60667L7.89615 1L12.1461 1.61333L13.349
            4.60333M12.467 12.1933L12.2264 19.5533M6.61321 12.1933L6.85377 19.63M1.56128
            7.74667H17.4386L16.6368 21.7C16.5566 22.9267 15.5141 24 14.2311 24H4.76883C3.40562 24
            2.44336 22.9267 2.36317 21.7L1.56128 7.74667Z" stroke="#999999" stroke-width="2"
                    stroke-miterlimit="22.9256" stroke-linecap="round" stroke-linejoin="round">
              </path>
            </svg>
          </button>
          <router-link class="detailsPage__edit" :to="`/wizard/${this.slopeId}/`">
            <img src="@/assets/img/cog-white.svg" alt="cog">
            Edit area
          </router-link>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row slopePage__pane detailsPage__pane">
        <div class="col-lg-5 col-md-5">
          <div class="detailsPage__info">
            <div class="detailsPage__info-text">
              Number of slopes:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{ slopeFromState.slopeCount }}</b>
            </div>
          </div>
          <div class="detailsPage__info detailsPage__info-only"
               v-if="(slopeFromState.slopeType === 'contrSlope') &&
               (slopeFromState.fixtureCalculation.need === true)">
            <div class="detailsPage__info-text">
              Main slope:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b v-if="slopeFromState.fixtureCalculation.base === 'default'">
                оrganized by construction
              </b>
              <b v-else-if="slopeFromState.fixtureCalculation.base === 'custom'">
              {{ slopeFromState.fixtureCalculation.material.name }}
              </b>
            </div>
          </div>
          <div class="detailsPage__info">
            <div class="detailsPage__info-text">
              Area of one slope:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{square}} m²</b>
            </div>
          </div>
          <div class="detailsPage__info">
            <div class="detailsPage__info-text">
              The total volume of the 1st slope:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{singleVolume}} m³</b>
            </div>
          </div>
          <div class="detailsPage__info">
            <div class="detailsPage__info-text">
              The total volume of all slopes:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{totalVolume}} m³</b>
            </div>
          </div>
          <div class="detailsPage__info">
            <div class="detailsPage__info-text">
              Number of rows:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{rowsCount}}</b>
            </div>
          </div>
        </div>
        <div class="col-lg-7 col-md-7 detailsPage__info-right">
          <div class="detailsPage__info detailsPage__info--doubleRow">
            <div class="detailsPage__info-text">
              Selected Material:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{ allMaterials[index].name }}
                <img src="@/assets/img/angle.svg" alt="angle">
                {{ allMaterials[index].angle }}
              </b>
            </div>
          </div>
          <div class="detailsPage__info detailsPage__info--doubleRow">
            <div class="detailsPage__info-text">
              Panel dimension:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>
                {{ slopeFromState.materialSize.width}}x{{ slopeFromState.materialSize.height }} mm
              </b>
            </div>
          </div>
          <div class="detailsPage__info detailsPage__info--doubleRow">
            <div class="detailsPage__info-text">
              Number of tapered insulation <br>layers:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{ slopeFromState.slopeLayersCount }}</b>
            </div>
          </div>
          <div class="detailsPage__info fixture">
            <div class="detailsPage__info-text">
              Fasteners calculation:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data unprint">
              <div class="toggler"
                   :class="{active: slopeFromState.fixtureCalculation.need === true}">
                <div class="track"></div>
                <div class="toggler__btn"></div>
              </div>
            </div>
          </div>
          <div class="detailsPage__info detailsPage__info--doubleRow"
               v-if="slopeFromState.fixtureCalculation.need === true">
            <div class="detailsPage__info-text">
              Type of roof base:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b v-if="slopeFromState.fixtureCalculation.type === 'concrete'">Concrete</b>
              <b v-else-if="slopeFromState.fixtureCalculation.type === 'OSB'">OSB</b>
              <b v-else>Corrugated steel sheet</b>
            </div>
          </div>
          <div class="detailsPage__info detailsPage__info--doubleRow"
               v-if="slopeFromState.fixtureCalculation.need === true">
            <div class="detailsPage__info-text">
              Primary insulation thickness <br>without reference to the material:
            </div>
            <div class="detailsPage__info-text detailsPage__info-text--data">
              <b>{{ slopeFromState.fixtureCalculation.thickness }} mm</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetailsPlateLayout :materialAngle="allMaterials[index].angleValue"
                        :fixtureCalculationThickness="slopeFromState.fixtureCalculation.thickness"
                        :masonryType="allMaterials[index].params[indexOfMaterialSize].type"
                        :hKr="allMaterials[index].params[indexOfMaterialSize].hKr"
                        :qKr="allMaterials[index].params[indexOfMaterialSize].qKr"
                        :y1="allMaterials[index].params[indexOfMaterialSize].y1"
                        :y2="allMaterials[index].params[indexOfMaterialSize].y2"
                        :backEndRowsCount = "rowsCount"
                        ref="plateLayout"/>
    <DetailsMaterialsComputation :count="slopeFromState.slopeCount"/>
    <DetailsFastener :count="slopeFromState.slopeCount"/>
    <DetailsGrouping :count="slopeFromState.slopeCount"/>
    <DetailsAddons :materialProp="slopeFromState.material"/>
    <ResultNav :isDetails="true"/>
    <Prefooter @savePdf="savePdf()" @saveXls="saveXls()" />
    <Footer />
    <transition name="fading">
      <DeleteConfirmation v-if="isShowDeleteConfirmation"
                          @confirm="deleteSlope()"
                          @cancel="isShowDeleteConfirmation = !isShowDeleteConfirmation"/>
    </transition>
  </section>
</template>

<script>
import { saveAs } from 'file-saver';
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import axios from 'axios';
import { isSafari } from '@/utils/utils';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import Prefooter from '../components/Prefooter.vue';
import DetailsPlateLayout from '../components/details/DetailsPlateLayout.vue';
import DetailsMaterialsComputation from '../components/details/DetailsMaterialsComputation.vue';
import DetailsFastener from '../components/details/DetailsFastener.vue';
import DetailsGrouping from '../components/details/DetailsGrouping.vue';
import DetailsAddons from '../components/details/DetailsAddons.vue';
import ResultNav from '../components/result/ResultNav.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';

export default {
  props: {
    slope: Object,
  },
  data() {
    return {
      fullPage: true,
      isLoading: false,
      isShowDeleteConfirmation: false,
    };
  },
  components: {
    Header,
    Footer,
    Prefooter,
    DetailsPlateLayout,
    DetailsMaterialsComputation,
    DetailsFastener,
    DetailsGrouping,
    DetailsAddons,
    ResultNav,
    DeleteConfirmation,
    Loading,
  },
  methods: {
    deleteSlope() {
      // console.log(this.allSlopes.length - 1);
      // console.log((this.allSlopes.length - 1) === parseInt(this.slopeId));
      if ((this.allSlopes.length - 1) === parseInt(this.slopeId, 10)) {
        this.$store.commit('deleteSlope', this.slopeId);
        this.$router.push('/result/');
        this.$root.onBodyScroll();
      } else {
        this.$store.commit('deleteSlope', this.slopeId);
        this.$root.onBodyScroll();
        this.$router.push('/result/');
      }

      // this.$store.commit('deleteSlope', this.slopeId);
    },
    savePdf() {
      // console.log(document.querySelector('.figure__wrapper-details svg').outerHTML);
      this.isLoading = true;
      const baseUrl = (process.env.NODE_ENV === 'development') ? 'http://en.tn-calc.industrialmedia.com.ua/action/' : `${window.location.origin}/`;
      const image = this.$refs.plateLayout.$refs.svgComponent.$refs.figure.outerHTML;
      const string = new URLSearchParams();
      const postData = {};
      const postDataHeader = {};
      const postDataFront = {};
      postDataFront.userInfo = this.userInfo;
      postDataFront.year = new Date().getFullYear();
      postData.groups = this.groups;
      postData.fasteners = this.fasteners;
      postData.rows = this.rowsToPdf;
      postData.material = this.computation;
      postData.albums = this.result.sections[this.$route.params.id].albums;
      postData.fixtureCalculationNeed = `${this.slopeFromState.fixtureCalculation.need}`;
      postDataHeader.title = `${this.slopeFromState.name}. ${this.slopeFromState.slopeType === 'mainSlope' ? 'Main slope' : 'Counter slope'}`;
      postDataHeader.slopeCount = this.slopeFromState.slopeCount;
      postDataHeader.square = this.square;
      postDataHeader.singleVolume = this.singleVolume;
      postDataHeader.totalVolume = this.totalVolume;
      postDataHeader.rowsCount = this.rowsCount;
      postDataHeader.material = `${this.allMaterials[this.index].name} ${this.allMaterials[this.index].angle}`;
      postDataHeader.sizes = `${this.slopeFromState.materialSize.width}x${this.slopeFromState.materialSize.height} mm`;
      postDataHeader.fixtureCalculationNeed = !this.slopeFromState.fixtureCalculation.need ? 'not provided' : '';
      if (this.slopeFromState.slopeType === 'contrSlope') {
        if (this.slopeFromState.fixtureCalculation.need) {
          postDataHeader.fixtureCalculationBase = (this.slopeFromState.fixtureCalculation.base === 'default') ? 'оrganized by construction' : this.slopeFromState.fixtureCalculation.material.name;
        }
      }
      if (!this.slopeFromState.fixtureCalculation.need) {
        postDataHeader.fixtureCalculationType = 'no data';
        postDataHeader.fixtureCalculationThickness = 'no data';
      } else {
        if (this.slopeFromState.fixtureCalculation.type === 'concrete') {
          postDataHeader.fixtureCalculationType = 'concrete';
        } else if (this.slopeFromState.fixtureCalculation.type === 'OSB') {
          postDataHeader.fixtureCalculationType = 'OSB';
        } else {
          postDataHeader.fixtureCalculationType = 'corrugated steel sheet';
        }
        postDataHeader.fixtureCalculationThickness = `${this.slopeFromState.fixtureCalculation.thickness} mm`;
      }
      postData.header = postDataHeader;
      postData.firstPage = postDataFront;
      string.append('type', 'pdf_section');
      string.append('image', image);
      string.append('data', JSON.stringify(postData));
      // console.log(JSON.stringify(postData));
      axios.post(`${baseUrl}service_api/pdf`, string, {
        responseType: 'blob', // Force to receive data in a Blob Format
      })
        .then((response) => {
          // console.log(response.data);
          // Create a Blob from the PDF Stream
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' },
          );
          // Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          this.isLoading = false;
          if (this.isSafari) {
            const fileName = 'Detailed calculation.pdf';
            saveAs(file, fileName);
          } else {
            window.open(fileURL);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveXls() {
      this.isLoading = true;
      const fileName = 'Detailed calculation.xlsx';
      const baseUrl = (process.env.NODE_ENV === 'development') ? 'http://en.tn-calc.industrialmedia.com.ua/action/' : `${window.location.origin}/`;
      const string = new URLSearchParams();
      const postData = {};
      postData.section = this.section;
      postData.page = 'section';
      if (this.slopeFromState.fixtureCalculation.need) {
        postData.thickness = this.slopeFromState.fixtureCalculation.thickness;
      }
      string.append('data', JSON.stringify(postData));
      axios.post(`${baseUrl}service_api/excel`, string, {
        responseType: 'blob', // Force to receive data in a Blob Format
      })
        .then((response) => {
          // console.log(response);
          // Create a Blob from the PDF Stream
          const file = new Blob(
            [response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
          );
          // Build a URL from the file
          // const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          this.isLoading = false;
          // window.open(fileURL);
          saveAs(file, fileName);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    if (this.allSlopes[0].material === '') {
      this.$router.push('/');
      console.clear();
    }
  },
  watch: {
    isShowDeleteConfirmation() {
      if (this.isShowDeleteConfirmation) {
        this.$root.offBodyScroll();
      } else {
        this.$root.onBodyScroll();
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    isSafari() {
      return isSafari();
    },
    index() {
      return this.allMaterials.findIndex(p => p.id === this.slopeFromState.material);
    },
    indexOfMaterialSize() {
      return this.allMaterials[this.index].params.findIndex(p => p.id
        === this.slopeFromState.materialSize.id);
    },
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    result() {
      return this.$store.getters.getResult;
    },
    section() {
      return this.result.sections[this.slopeId];
    },
    rowsCount() {
      return this.result.sections[this.$route.params.id].rowsCount;
    },
    singleVolume() {
      return this.result.sections[this.$route.params.id].volumeSingle;
    },
    totalVolume() {
      return this.result.sections[this.$route.params.id].volumeTotal;
    },
    square() {
      return this.result.sections[this.$route.params.id].square;
    },
    groups() {
      return this.result.sections[this.$route.params.id].fasteners_group;
    },
    fasteners() {
      return this.result.sections[this.$route.params.id].fasteners;
    },
    rowsToPdf() {
      return this.$store.getters.getRowsToPdf;
    },
    computation() {
      return this.result.sections[this.$route.params.id].computation;
    },
  },
};
</script>

<style lang="sass" scoped>
.detailsPage
  color: $black
  .delete
    &__btn
      margin-right: rem(6)
  &__nav
    display: flex
    flex-direction: row
    align-items: center
    flex-wrap: wrap
    +media((padding: (320: rem(22) rem(24) rem(27) rem(24), 992: rem(24) 0 rem(17) 0)))
    &-btn
      color: $red
      border: rem(1) solid rgba(227, 7, 19, 0.5)
      box-sizing: border-box
      border-radius: rem(4)
      display: flex
      flex-direction: row
      align-items: center
      justify-content: center
      box-shadow: none
      background: none
      outline: none
      transition: .5s
      font-style: normal
      font-weight: 600
      font-size: rem(12)
      line-height: rem(24)
      font-family: $main-font
      height: rem(34)
      cursor: pointer
      text-decoration: none
      margin-right: rem(4)
      margin-top: rem(10)
      +media((min-width: (320: rem(145), 768: rem(158))))
      svg
        margin-right: rem(11)
        path
          transition: .5s
      &:hover
        background: $red
        color: #fff
        svg
          path
            stroke: #fff
    &-label
      font-style: normal
      font-weight: 500
      font-size: rem(12)
      line-height: rem(24)
      text-align: center
      color: #5C5C5C
      background: #F6F6F6
      border-radius: rem(4)
      min-height: rem(34)
      text-align: left
      display: flex
      flex-direction: row
      align-items: center
      justify-content: center
      flex-wrap: wrap
      margin-top: rem(10)
      padding: 0 rem(16)
      +media((min-width: (320: rem(131), 768: rem(142))))
  &__title
    font-style: normal
    font-weight: 500
    text-align: left
    +media((font-size: (320: rem(20), 768: rem(28))))
    +media((line-height: (320: rem(26), 768: rem(34))))
    +media((padding-bottom: (320: rem(27), 576: 0)))
    &-box
      +media((padding-right: (320: rem(24), 992: 0)))
      +media((padding-left: (320: rem(24), 992: 0)))
  &__edit
    background: $red
    border-radius: rem(4)
    transition: .5s
    color: #fff
    font-style: normal
    font-weight: bold
    font-size: rem(14)
    line-height: rem(17)
    text-decoration: none
    display: flex
    flex-direction: row
    align-items: center
    +media((padding: (320: rem(15) rem(15), 360: rem(15) rem(23) rem(15) rem(20),
    768: rem(15) rem(27) rem(15) rem(22))))
    img
      +media((margin-right: (320: rem(10), 992: rem(20))))
      transition: .5s
    &:hover
      background: $red-hover
      img
        transform: rotate(-180deg)
  &__pane
    +media((margin-top: (320: rem(32), 768: rem(43))))
    +media((padding-bottom: (320: rem(24), 768: rem(34))))
  &__info
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    +media((padding-left: (320: rem(9), 992: rem(25))))
    +media((padding-bottom: (320: rem(14), 768: rem(16))))
    &-only
      +media((flex-direction: (320: column, 480: row, 768: column)))
      +media((align-items: (320: flex-start, 480: center, 768: flex-start)))
      .detailsPage__info-text--data
        +media((width: (320: auto, 480: rem(200), 768: auto)))
    &.fixture
      +media((padding-top: (320: rem(16), 768: rem(34))))
      .detailsPage__info-text--data
        +media((min-width: (320: unset, 480: rem(200))))
        +media((padding-right: (320: rem(9), 768: 0)))
    &-right
      .detailsPage__info-text--data
        min-width: rem(200)
    &--doubleRow
      +media((flex-direction: (320: column, 480: row)))
      +media((align-items: (320: flex-start, 480: center)))
      +media((padding-top: (320: rem(10), 480: 0)))
      +media((padding-bottom: (320: rem(10), 480: rem(14))))
      .detailsPage__info-text
        +media((padding-bottom: (320: rem(9), 480: 0)))
      .detailsPage__info-text--data
        +media((width: (320: auto, 480: rem(200))))
    &-text
      font-style: normal
      font-weight: 500
      font-size: rem(14)
      line-height: rem(18)
      text-align: left
      &--data
        // min-width: rem(80)
        text-align: left
        +media((width: (320: rem(80), 480: rem(200), 768: rem(96))))
        .toggler
          position: relative
          width: rem(42)
          .track
            width: rem(42)
            height: rem(14)
            background: #ECECEC
            box-shadow: inset 0 rem(2) rem(4) #D6D6D6
            border-radius: rem(12)
          &__btn
            background: #ffffff
            box-shadow: 0 rem(3) rem(6) rgba(0, 0, 0, 0.16)
            height: rem(24)
            width: rem(24)
            border-radius: 50%
            transition: .5s
            position: absolute
            top: 50%
            transform: translateY(-50%)
            left: rem(-6)
            right: auto
          &.active
            .toggler__btn
              background: $red
              right: rem(-6)
              left: auto
</style>
